import { Map } from 'immutable';
import { Reducer } from '../../Reducer';
import { NOTIFY_ALERT_SET_ITEMS } from './types';

export const INITIAL_STATE = Map({
    unread_notification_count: 0,
    notification_count: 0,
});

export default class NotificationAlertReducer extends Reducer {
    NAME = 'NotificationAlert';
    alias = {
        [NOTIFY_ALERT_SET_ITEMS]: 'onSetItems',
    };

    /**
     *
     * @param state
     * @param action
     * @returns {*|Immutable.Map<any, any>|Immutable.Map<string, any>}
     * @constructor
     */
    onSetItems(state = INITIAL_STATE, action) {
        const { name, value } = action.payload;

        if (!name) {
            return state;
        }

        return state.set(name, value);
    }
    /**
     *
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, Array|{}|boolean>}
     */
    onDefault(state = INITIAL_STATE) {
        return state;
    }
}
